// src/components/promotions/PromotionsTable.js
import React from 'react';
import { PencilIcon, PlayIcon, PauseIcon, EyeIcon } from '@heroicons/react/24/outline';

const PromotionsTable = ({ promotions, onEditPromotion, onChangeStatus }) => {
    const getStatusClasses = (status) => {
        switch (status) {
            case 'Active': return 'bg-green-100 text-green-800';
            case 'Inactive': return 'bg-gray-100 text-gray-800';
            case 'Upcoming': return 'bg-blue-100 text-blue-800';
            case 'Expired': return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden mt-6">
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Target Audience
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Period
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Usage
                        </th>
                        <th scope="col" className="relative px-6 py-3">
                            <span className="sr-only">Actions</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {promotions.length === 0 ? (
                        <tr>
                            <td colSpan="7" className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                No promotions found matching your criteria.
                            </td>
                        </tr>
                    ) : (
                        promotions.map((promo) => (
                            <tr key={promo.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">{promo.name}</div>
                                    <div className="text-xs text-gray-500 truncate max-w-xs">{promo.details}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-600">{promo.type}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-600">{promo.target}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClasses(promo.status)}`}>
                      {promo.status}
                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                    {promo.startDate} - {promo.endDate}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    Used: {promo.usage.toLocaleString()} {promo.type !== 'Bonus Points' && ` / Redeemed: ${promo.redemptions.toLocaleString()}`}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <button
                                        onClick={() => onEditPromotion(promo)}
                                        className="text-indigo-600 hover:text-indigo-900 p-1 rounded-full hover:bg-gray-100 transition-colors"
                                        title="Edit Promotion"
                                    >
                                        <PencilIcon className="h-5 w-5" />
                                    </button>
                                    {promo.status === 'Active' && (
                                        <button
                                            onClick={() => onChangeStatus(promo.id, 'Inactive')}
                                            className="text-red-600 hover:text-red-900 p-1 rounded-full hover:bg-gray-100 transition-colors ml-2"
                                            title="Deactivate Promotion"
                                        >
                                            <PauseIcon className="h-5 w-5" />
                                        </button>
                                    )}
                                    {promo.status === 'Inactive' && (
                                        <button
                                            onClick={() => onChangeStatus(promo.id, 'Active')}
                                            className="text-green-600 hover:text-green-900 p-1 rounded-full hover:bg-gray-100 transition-colors ml-2"
                                            title="Activate Promotion"
                                        >
                                            <PlayIcon className="h-5 w-5" />
                                        </button>
                                    )}
                                    <button
                                        // This would open a detailed view of promotion performance
                                        onClick={() => alert('View performance for ' + promo.name)}
                                        className="text-gray-600 hover:text-gray-900 p-1 rounded-full hover:bg-gray-100 transition-colors ml-2"
                                        title="View Performance"
                                    >
                                        <EyeIcon className="h-5 w-5" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
            {/* Pagination can be added here if needed */}
        </div>
    );
};

export default PromotionsTable;